module.exports = __webpack_public_path__ + "static/media/grandmomKhauna.70bc22ee.svg";